// ---------------------------------------------------------------------------
// The language a page is written in (R3)
//
// The app is English; the admin area (/admin, /admin/login) is German. Both
// the server's HTML shell (entrypoints/sdr/src/server/html-shell.ts) and the
// router (on every route change, since moving between the two areas does not
// reload the page) ask this one function, so <html lang> names the area's
// language. Text in the other language says so itself (lang on the element,
// as the German legal texts do on the English app pages).
// ---------------------------------------------------------------------------

export type PageLang = 'en' | 'de';

/** German for the admin area, English for everything else. */
export function pageLang(path: string): PageLang {
  return path === '/admin' || path.startsWith('/admin/') ? 'de' : 'en';
}
